import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { EntityLink as Link } from '../../navigation/navigation'
import { translateApiError } from '../../utils/errorMessages'
import api from '../../services/api'
import { usePageHeader } from '../../contexts/PageHeaderContext'
import { Button, Input } from '../../components/ui'
import './Admin.css'

function BudgetRules() {
  const [searchParams] = useSearchParams()
  const distributionTypeFromUrl = searchParams.get('distribution_type') || ''
  const [grouped, setGrouped] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchQuery, setSearchQuery] = useState(distributionTypeFromUrl)

  usePageHeader({
    renderActions: () => (
      <Link to="/admin/budget/budget-rules/new">
        <Button variant="primary">+ Новый тип распределения</Button>
      </Link>
    )
  }, [])

  useEffect(() => {
    fetchRules()
  }, [])

  const fetchRules = async () => {
    try {
      setLoading(true)
      const response = await api.get('/admin/budget/budget-rules')
      if (response.data) {
        setGrouped(response.data.grouped || [])
      }
    } catch (error) {
      console.error('Error fetching budget rules:', error)
      alert('Ошибка загрузки данных: ' + translateApiError(error.response?.data?.error || error.message))
    } finally {
      setLoading(false)
    }
  }

  const filteredGrouped = grouped.filter((typeGroup) => {
    if (!searchQuery.trim()) return true
    const query = searchQuery.toLowerCase().trim()
    const distributionType = (typeGroup.distribution_type || '').toLowerCase()
    return distributionType.includes(query)
  })

  if (loading) {
    return <div className="loading">Загрузка...</div>
  }

  return (
    <div className="admin-page">
      <div className="section-card">
        <div className="section-card-header">
          <h2>Типы распределения</h2>
          <div style={{ display: 'flex', gap: 'var(--spacing-sm)', alignItems: 'center', flexWrap: 'wrap' }}>
            <Input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Поиск по типу распределения..."
              className="admin-search-input"
            />
          </div>
        </div>
        <p className="admin-subtitle" style={{ marginTop: 0 }}>
          {searchQuery.trim()
            ? `Найдено типов: ${filteredGrouped.length} (из ${grouped.length})`
            : `Всего типов: ${grouped.length}`}
        </p>
        {grouped.length === 0 ? (
          <p style={{ margin: 'var(--spacing-lg) 0', color: 'var(--color-text-secondary)' }}>Нет данных. Создайте первый тип распределения.</p>
        ) : filteredGrouped.length === 0 ? (
          <p style={{ margin: 'var(--spacing-lg) 0', color: 'var(--color-text-secondary)' }}>Ничего не найдено</p>
        ) : null}
      </div>

      {filteredGrouped.length > 0 && (
        <div className="section-card">
          <div className="admin-table-frame">
            <div className="table-responsive">
              <table className="ui-table data-table">
                <thead>
                  <tr>
                    <th>Тип распределения</th>
                    <th>Количество правил</th>
                    <th>Сумма процентов</th>
                    <th style={{ width: '260px' }}>Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredGrouped.map((typeGroup) => {
                    const sumPct = (typeGroup.teams || []).reduce((s, t) => s + (Number(t.percentage) || 0), 0)
                    return (
                      <tr key={typeGroup.distribution_type}>
                        <td>{typeGroup.distribution_type || '—'}</td>
                        <td>{(typeGroup.teams || []).length}</td>
                        <td>{sumPct.toFixed(2)}%</td>
                        <td>
                          <div className="admin-row-actions">
                            <Link to={`/admin/budget/budget-rules/${encodeURIComponent(typeGroup.distribution_type_id || typeGroup.distribution_type || '')}/edit`}>
                              <Button variant="secondary" size="sm">Редактировать</Button>
                            </Link>
                            <Link to={`/admin/budget/budget-rules/new?copy_from=${encodeURIComponent(typeGroup.distribution_type_id || typeGroup.distribution_type || '')}`}>
                              <Button variant="outline" size="sm">Скопировать</Button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default BudgetRules
